import { useId } from 'react';
import { usePM2DisplayContext } from '@pm2/store';
import { Link } from '@provider/navigation';
import { resets } from '@ui/css';
import { PostloadedImage } from '@utils/react';
import { wrapper, tokens, container, imageButton, linkSurface, link } from './atom.slide.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function Slide(props) {
  const {
    inLightbox
  } = usePM2DisplayContext();
  const id = useId();
  const image = /*#__PURE__*/jsx(PostloadedImage, {
    src: props.model.image.src,
    width: props.model.image.width,
    height: props.model.image.height,
    alt: props.model.image.alt ?? "",
    loading: props.isCurrent ? "eager" : "lazy",
    sizes: "min(100vw, 1110px)"
  });
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    style: {
      left: `${props.index * 100}%`
    },
    children: /*#__PURE__*/jsxs("div", {
      className: container,
      style: tokens.__override({
        aspectRatio: `${props.model.image.width} / ${props.model.image.height}`
      }),
      children: [inLightbox ? image : /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("button", {
          className: imageButton,
          "aria-describedby": id,
          onClick: props.handleOpenSlideInLightbox,
          children: image
        }), /*#__PURE__*/jsx("div", {
          id: id,
          className: resets.screenReaderOnlyCls,
          children: "\xC5bn billede i lightbox"
        })]
      }), /*#__PURE__*/jsx(SlideLink, {
        link: props.model.link,
        isCurrent: props.isCurrent
      })]
    })
  });
}
function SlideLink(props) {
  if (!props.link) {
    return null;
  }
  return /*#__PURE__*/jsx(Link, {
    href: props.link.href,
    target: props.link.target,
    className: link,
    style: linkSurface.__override({
      color: props.link.color,
      background: props.link.background
    }),
    tabIndex: props.isCurrent ? undefined : -1,
    children: props.link.label
  });
}

export { Slide };
//# sourceMappingURL=atom.slide.js.map
